import { useState, lazy, Suspense } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'
import { useEnhancedBrandStore } from '../../stores/enhancedBrandStore'
import { ChartLoadingState } from '../charts/ChartLoadingState'

// Lazy load the map component
const USMapChart = lazy(() => import('../charts/USMapChart').then(m => ({ default: m.USMapChart })))

export function USMapSection() {
  const { filteredBrands, isLoading } = useEnhancedBrandStore()
  const [isCollapsed, setIsCollapsed] = useState(false)

  if (isLoading || filteredBrands.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700">
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                US Geographic Distribution
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                Brand locations across the United States
              </p>
            </div>
          </div>
        </div>
        <div className="p-6">
          {isLoading ? (
            <div className="flex items-center justify-center h-64">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
              <span className="ml-3 text-gray-600 dark:text-gray-300">
                Loading map...
              </span>
            </div>
          ) : (
            <div className="flex items-center justify-center h-64 text-gray-500 dark:text-gray-400">
              No data to display. Try adjusting your filters.
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700">
      {/* Map Header */}
      <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              US Geographic Distribution
            </h2>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              {filteredBrands.length.toLocaleString()} brands across the United States
            </p>
          </div>
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="p-1 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
            title={isCollapsed ? 'Expand Map' : 'Collapse Map'}
          >
            {isCollapsed ? (
              <ChevronDownIcon className="h-5 w-5" />
            ) : (
              <ChevronUpIcon className="h-5 w-5" />
            )}
          </button>
        </div>
      </div>
      
      {!isCollapsed && (
        <div className="p-6">
          <Suspense fallback={<ChartLoadingState message="Loading geographic map..." />}>
            <USMapChart />
          </Suspense>
        </div>
      )}
    </div>
  )
}